var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.iconSize,"height":_vm.iconSize,"viewBox":"0 0 25 25","role":"presentation"}},[_c(_vm.icon,{tag:"component",style:(`stroke-width: ${_vm.strokeWidth};`)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }